<script>
    export let room;
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    function emitRoom(){
        dispatch('room', {
            room: room
        });
    }

</script>

<div class:active="{room.isActive == true}" class="room" on:click={emitRoom}>
    <p class="roomName">{room.roomName}</p>
    <p>{room.newMessages} new messages</p>
</div>

<style>
    .active {
        background-color: #707070;
    }

    .active * {
        color: white;
    }

    .room {
        width: 100%;
        padding: 10px;
        border-bottom: solid 1px #707070;
    }

    .roomName {
        font-weight: bold;
    }
</style>